<!--
 * @Description  : 订单列表
 * @Author       : git config user.sname
 * @Date         : 2025-12-27 13:42:16
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-04-09 15:18:30
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\order-management\order-list\index.vue
-->
<template>
	<div class="h100 operation-layout order-list">
		<filter-layout @search="doSearch" @reset="resetSerach" hasMore hasHeader v-if="!routeQuery">
			<template #header>
				<el-tabs v-model="activeTab" @tab-click="tabChange(activeTab)">
					<el-tab-pane name="valueAdd" label="增值服务订单"> </el-tab-pane>
					<el-tab-pane name="project" label="项目服务订单"> </el-tab-pane>
				</el-tabs>
			</template>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" label-width="130px" :model="searchForm">
					<el-form-item label="订单编号：" prop="orderNo">
						<el-input :placeholder="'请输入'" size="small" v-model="searchForm.orderNo" clearable> </el-input>
					</el-form-item>

					<!-- 增值服务 查询条件 -->
					<template v-if="activeTab == 'valueAdd'">
						<el-form-item label="下单人：" prop="createUser">
							<el-input :placeholder="'请输入'" size="small" v-model="searchForm.createUser" clearable> </el-input>
						</el-form-item>
						<el-form-item label="归属方：" prop="owner">
							<el-input :placeholder="'请输入'" size="small" v-model="searchForm.owner" clearable> </el-input>
						</el-form-item>
						<el-form-item label="创建时间：" prop="dateArr">
							<el-date-picker
								v-model="searchForm.dateArr"
								type="daterange"
								clearable
								placeholder="请选择"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-dd"
							></el-date-picker>
						</el-form-item>
					</template>

					<!-- 项目服务 查询条件 -->
					<template v-if="activeTab == 'project'">
						<el-form-item label="项目名称：" prop="proName">
							<el-input :placeholder="'请输入'" size="small" v-model="searchForm.proName" clearable> </el-input>
						</el-form-item>
						<el-form-item label="标段（包）名称：" prop="packName">
							<el-input :placeholder="'请输入'" size="small" v-model="searchForm.packName" clearable> </el-input>
						</el-form-item>
						<el-form-item label="项目编号：" prop="proNo">
							<el-input :placeholder="'请输入'" size="small" v-model="searchForm.proNo" clearable> </el-input>
						</el-form-item>
					</template>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef2" label-width="130px" :model="searchForm">
					<el-form-item label="商品名称：">
						<el-input :placeholder="'请输入'" size="small" v-model="searchForm.busName" clearable> </el-input>
					</el-form-item>
					<el-form-item label="订单状态：">
						<el-select v-model="searchForm.status" size="small" clearable>
							<el-option v-for="item in orderStatus" :key="item.value" :label="item.sname" :value="item.value"> </el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="开票状态：">
						<el-select v-model="searchForm.invoiceState" size="small" clearable>
							<el-option v-for="item in invoiceState" :key="item.value" :label="item.sname" :value="item.value"> </el-option>
						</el-select>
					</el-form-item>
					<!-- 项目服务 查询条件 -->
					<template v-if="activeTab == 'project'">
						<el-form-item label="创建时间：" prop="dateArr">
							<el-date-picker
								v-model="searchForm.dateArr"
								type="daterange"
								clearable
								placeholder="请选择"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-dd"
							></el-date-picker>
						</el-form-item>
						<el-form-item label="归属方：" prop="owner">
							<el-input :placeholder="'请输入'" size="small" v-model="searchForm.owner" clearable> </el-input>
						</el-form-item>
					</template>
				</el-form>
			</template>
			<template #content>
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							订单合计：<span class="blue">{{ tableObj.total }}</span> 个
						</div>
						<div class="btnGroups">
							<el-button type="primary" size="mini" plain @click="doExport">数据导出</el-button>
							<el-button type="primary" class="ml5 btn-blue" size="mini" @click="resetSerach">
								<i class="el-icon-refresh"></i>
							</el-button>
						</div>
					</div>
				</div>
				<div class="operation-container w-table-layout w-table-page" v-loading="tableObj.loading">
					<div class="w-table-content" v-if="tableShow">
						<vxe-table
							ref="xTable"
							:data="tableObj.tableData"
							highlight-current-row
							highlight-hover-row
							align="left"
							border
							height="100%"
							size="small"
							auto-resize
							resizable
							show-overflow="tooltip"
							show-header-overflow="tooltip"
						>
							<vxe-table-column type="seq" title="序号" width="60px" align="center"></vxe-table-column>
							<vxe-table-column field="orderNo" title="订单编号" width="160px" align="center"></vxe-table-column>
							<vxe-table-column field="orderType" title="订单类型" width="130px" align="center" v-if="activeTab == 'valueAdd'">
								<template v-slot="{ row }">
									<span>{{ row.orderType == '0' ? '企业关联订单' : row.orderType == '1' ? '个人订单' : '' }}</span>
								</template>
							</vxe-table-column>
							<vxe-table-column
								field="proName"
								title="项目名称"
								min-width="200px"
								align="center"
								v-if="activeTab == 'project'"
							></vxe-table-column>
							<vxe-table-column
								field="proNo"
								title="项目编号"
								min-width="180px"
								align="center"
								v-if="activeTab == 'project'"
							></vxe-table-column>
							<vxe-table-column
								field="packName"
								title="标段（包）名称"
								min-width="180px"
								align="center"
								v-if="activeTab == 'project'"
							></vxe-table-column>
							<vxe-table-column field="busName" title="商品名称" min-width="150px" align="center"></vxe-table-column>
							<vxe-table-column field="orderAm" title="订单金额" width="120px" align="center">
								<template v-slot="{ row }">
									<span>{{ row.orderAm + '元' }}</span>
								</template>
							</vxe-table-column>
							<vxe-table-column
								field="createUser"
								title="下单人"
								width="120px"
								align="center"
								v-if="activeTab == 'valueAdd'"
							></vxe-table-column>
							<vxe-table-column field="owner" title="归属方" min-width="160px" align="center"></vxe-table-column>
							<vxe-table-column field="invoiceState" title="开票状态" width="110px" align="center">
								<template v-slot="{ row }">
									<span>{{ getInvoiceStatus(row.invoiceState) }}</span>
								</template>
							</vxe-table-column>
							<vxe-table-column field="status" title="订单状态" width="120px" align="center">
								<template v-slot="{ row }">
									<span>{{ getOrderStatus(row.status) }}</span>
								</template>
							</vxe-table-column>
							<vxe-table-column field="createDate" title="创建时间" width="160px" align="center"></vxe-table-column>
							<vxe-table-column title="操作" width="160px" align="left">
								<template v-slot="{ row }">
									<el-button class="table-btn" type="primary" round plain size="small" @click="handleClick('view', row)">
										<svg-icon icon-class="form-look"></svg-icon>
										查看
									</el-button>
									<el-button
										class="table-btn"
										type="info"
										round
										plain
										size="small"
										@click="handleClick('cancel', row)"
										v-if="row.status == 0"
									>
										<svg-icon icon-class="form-give-up"></svg-icon>
										取消
									</el-button>
									<el-button
										class="table-btn"
										type="danger"
										round
										plain
										size="small"
										@click="handleClick('delete', row)"
										v-if="row.status == 3"
									>
										<svg-icon icon-class="form-delete"></svg-icon>
										删除
									</el-button>
									<el-button
										class="table-btn"
										type="warning"
										round
										plain
										size="small"
										@click="handleClick('refund', row)"
										v-if="row.status == 1"
									>
										<svg-icon icon-class="form-refund"></svg-icon>
										退款
									</el-button>
								</template>
							</vxe-table-column>
						</vxe-table>
					</div>
					<div class="w-table-footer">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="tableObj.currentPage"
							:page-size="tableObj.pageSize"
							:page-sizes="[10, 20, 50, 100]"
							layout="total, sizes, prev, pager, next, jumper"
							:total="tableObj.total"
						>
						</el-pagination>
					</div>
				</div>
			</template>

			<!-- 退款弹窗 -->
			<RefundDialog ref="refundDialog" @doRefresh="doSearch"></RefundDialog>
		</filter-layout>
		<div class="check-setting" v-else-if="routeQuery == 'check'">
			<detailVue @close="doSearch"></detailVue>
		</div>
	</div>
</template>
<script>
import { exportPlus } from 'utils/tools'
import { mapState } from 'vuex'
import XEUtils from 'xe-utils'

import * as Api from '@/api/modules/order-management.js'

import detailVue from '../components/detail.vue'
import { bmStorage } from '../../../../utils/tools'
import RefundDialog from '../components/refund-dialog.vue'

export default {
	components: { detailVue, RefundDialog },
	data() {
		return {
			activeTab: 'valueAdd',
			searchForm: {
				orderNo: '', //订单编号
				createUser: '', //下单人
				owner: '', //归属方
				busName: '', //商品名称
				invoiceState: '', //开票状态
				dateArr: '',
				status: null, //订单状态
				proName: '',
				packName: '',
				proNo: ''
			},
			tableObj: {
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				loading: false
			},
			tableShow: true
		}
	},
	created() {
		if (bmStorage.sessionStorage.get('order-tab')) {
			this.activeTab = bmStorage.sessionStorage.get('order-tab')
			bmStorage.sessionStorage.remove('order-tab')
		}
		//分页
		this.doSearch()
	},
	methods: {
		//TODO tab切换
		tabChange(val) {
			this.tableObj.currentPage = 1
			this.tableObj.pageSize = 10
			this.tableShow = false
			this.getList()
			this.$refs.xTable.refreshColumn()
		},
		//查询
		doSearch() {
			this.getList()
		},
		//重置\刷新
		resetSerach() {
			this.searchForm = {
				sname: '', //商品名称
				proId: '', //商品ID
				createUser: '', //创建人
				status: '', //状态
				applySub: '', //归属主体
				dateArr: '',
				proAttr: '',
				proName: '',
				packName: '',
				proNo: ''
			}
			this.$refs.searchRef?.resetFields()
			this.$refs.searchRef2?.resetFields()
			// this.searchForm.dateArr = ''
			// this.searchForm.proAttr = []
			this.tableObj.currentPage = 1
			this.tableObj.pageSize = 10
			this.getList()
		},
		// 表格 每页条数切换
		handleSizeChange(size) {
			this.tableObj.pageSize = size
			this.doSearch()
		},

		// 表格 页码切换
		handleCurrentChange(cur) {
			this.tableObj.currentPage = cur
			this.doSearch()
		},
		//分页数据
		getList() {
			this.tableObj.loading = true
			let params = XEUtils.clone(this.searchForm, true)
			params.createStartDate = this.searchForm.dateArr ? this.searchForm.dateArr[0] : ''
			params.createEndDate = this.searchForm.dateArr ? this.searchForm.dateArr[1] : ''
			params.current = this.tableObj.currentPage
			params.size = this.tableObj.pageSize
			params.orderFlag = this.activeTab == 'valueAdd' ? 0 : 1 // 订单标识：0：增值服务订单；1：项目服务订单
			params.status = this.searchForm.status === '' ? null : this.searchForm.status
			delete params.dateArr
			Api.getOrderPage(params)
				.then((res) => {
					// this.tableObj.loading = false
					this.tableObj.tableData = res.data.records
					this.tableObj.total = parseInt(res.data.total)
				})
				.catch((err) => {
					// this.tableObj.loading = false
					this.tableObj.tableData = []
				})
				.finally(() => {
					setTimeout(() => {
						this.tableShow = true
					}, 10)
					setTimeout(() => {
						this.tableObj.loading = false
					}, 500)
				})
		},
		//订单状态
		getOrderStatus(type) {
			let text = ''
			switch (parseFloat(type)) {
				case 0:
					text = '待支付'
					break
				case 1:
					text = '已支付'
					break
				case 2:
					text = '支付失败'
					break
				case 3:
					text = '已取消'
					break
				case 4:
					text = '履约中'
					break
				case 5:
					text = '退款中'
					break
				case 6:
					text = '已退款（线下）'
					break
				case 7:
					text = '已退款（线上）'
					break
				case 8:
					text = '退款失败'
					break
				case 9:
					text = '已完成'
					break
				case 10:
					text = '已归档'
					break
			}
			return text
		},
		//订单状态
		getInvoiceStatus(type) {
			let text = ''
			switch (parseFloat(type)) {
				case -1:
					text = '未开票'
					break
				case 0:
					text = '开票中'
					break
				case 1:
					text = '已开票'
					break
				case 2:
					text = '开票失败'
					break
				case 3:
					text = '已红冲'
					break
				case 4:
					text = '红冲失败'
					break
			}
			return text
		},
		//按钮操作
		handleClick(type, obj) {
			switch (type) {
				case 'view':
					bmStorage.sessionStorage.set('order-tab', this.activeTab)
					this.$router.push({
						path: '/order-list',
						query: {
							type: 'check',
							orderId: obj.id
						}
					})
					break
				case 'delete':
					if (obj.status != 3) {
						return
					}
					this.$confirm('删除该订单后将无法恢复，是否确认删除？', '删除提醒', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							Api.delOrCancelOrder({ id: obj.id, flag: 0 })
								.then((res) => {
									this.$message.success('删除成功!')
									this.doSearch()
								})
								.catch((err) => {})
						})
						.catch(() => {})
					break
				case 'cancel':
					if (obj.status != 0) {
						return
					}
					this.$confirm('该订单处于待支付状态，是否确认取消？', '取消确认', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							Api.delOrCancelOrder({ id: obj.id, flag: 1 }) // flag 删除：0；取消：1
								.then((res) => {
									this.$message.success('取消成功!')
									this.doSearch()
								})
								.catch((err) => {})
						})
						.catch(() => {})
					break
				case 'refund':
					// 退款
					this.$refs.refundDialog.openDialog(obj)
					break
			}
		},

		//导出
		doExport() {
			let search = XEUtils.clone(this.searchForm, true)
			const params = {
				...search
			}
			params.createStartDate = this.searchForm.dateArr ? this.searchForm.dateArr[0] : ''
			params.createEndDate = this.searchForm.dateArr ? this.searchForm.dateArr[1] : ''
			params.orderFlag = this.activeTab == 'valueAdd' ? 0 : 1 // 订单标识：0：增值服务订单；1：项目服务订单
			delete params.dateArr
			let export_url = this.activeTab == 'valueAdd' ? '/bmPayment/exportOrderExcel' : '/bmPayment/exportProOrderExcel'
			exportPlus(export_url, params)
		}
	},
	computed: {
		//订单状态
		orderStatus() {
			let arr = [
				{
					sname: '待支付',
					value: '0'
				},
				{
					sname: '已支付',
					value: '1'
				},
				{
					sname: '支付失败',
					value: '2'
				},
				{
					sname: '已取消',
					value: '3'
				},
				{
					sname: '履约中',
					value: '4'
				},
				{
					sname: '退款中',
					value: '5'
				},
				{
					sname: '已退款(线下)',
					value: '6'
				},
				{
					sname: '已退款(线上)',
					value: '7'
				},
				{
					sname: '退款失败',
					value: '8'
				},
				{
					sname: '已完成',
					value: '9'
				},
				{
					sname: '已归档',
					value: '10'
				}
			]
			return arr
		},
		invoiceState() {
			let arr = [
				{
					sname: '未开票',
					value: '-1'
				},
				{
					sname: '开票中',
					value: '0'
				},
				{
					sname: '已开票',
					value: '1'
				},
				{
					sname: '开票失败',
					value: '2'
				},
				{
					sname: '已红冲',
					value: '3'
				},
				{
					sname: '红冲失败',
					value: '4'
				}
			]
			return arr
		},

		routeQuery() {
			return this.$route.query.type
		}
	}
}
</script>
<style lang="less" scoped>
.order-list {
	padding: 0 !important;

	/deep/ .more-layout {
		top: 55px;
		right: 370px;
	}

	/deep/ .el-tabs__item {
		width: 100px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		background: #f0f0f0;
		border-radius: 3px 3px 0px 0px;
		color: #666;
		margin-right: 20px;
		padding: 0;

		.el-tabs__header {
			border-bottom: 1px solid #2671cc;
		}
	}

	/deep/ .el-tabs__item.is-active {
		color: #fff;
		background-color: #2671cc !important;
	}

	/deep/ .el-tabs__nav-wrap::after {
		background-color: #2671cc;
		height: 1px;
		z-index: 999;
	}

	/deep/ .el-tabs__active-bar {
		background-color: transparent;
	}
}
</style>
